var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block"},[_c('el-carousel',{attrs:{"height":_vm.bannerHeight+'px'}},_vm._l((_vm.swiper),function(item,i){return _c('el-carousel-item',{key:i},[_c('img',{ref:"bannerHeight",refInFor:true,staticStyle:{"width":"100%"},attrs:{"src":item,"alt":""},on:{"load":_vm.imgLoad}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }